import { Component, Input, OnInit, Renderer2, ElementRef, ViewChild, AfterViewInit, Inject, PLATFORM_ID, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { SharedDataService } from 'src/app/shared/services/sharedata.service';
import { DynamicStyleService } from '../../utils/dynamic-styles.service';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-desktop-menu',
  templateUrl: './desktop-menu.component.html',
  styleUrls: ['./desktop-menu.component.scss']
})
export class DesktopMenuComponent implements OnInit, AfterViewInit  {
  enteredButton = false;
  isMatMenuOpen = false;
  isMatMenu2Open = false;
  prevButtonTrigger;
  @Input('categoriesMenu') categoriesMenu: [];
  @Input('allCategoriesMenu') allCategoriesMenu: [];
  @Input('theme') theme: '';
  featureTags = {};
  @ViewChild('menuButtonRef') element: ElementRef;


  constructor(private ren: Renderer2, public sharedDataService: SharedDataService, public router: Router, public styleService: DynamicStyleService, @Inject(PLATFORM_ID) private platformId: Object,) {
  }

  ngOnInit(){
    this.featureTags = JSON.parse(sessionStorage.getItem("featureTags")); 
    this.styleService.applyTheme(this.theme); 
    
  }
  @HostListener('window:resize', ['$event'])
    onResize() {
      if (this.featureTags && this.featureTags['sf_category_menu_flicker']) {
        this.onSceenChanges();
      }
  }
  
  ngAfterViewInit() {
    this.onSceenChanges();
  }

  onSceenChanges(){
    if (isPlatformBrowser(this.platformId)) {
      setTimeout(() => {
        if (this.element) {
          const { y } = this.element.nativeElement.getBoundingClientRect();
          const dynamicHeight = `calc(100vh - ${y+150}px)`;
          // Apply the value as a CSS variable
          document.documentElement.style.setProperty('--dynamic-height', dynamicHeight);          
        }
      });
    }
  }

  openSidenav() {
    this.sharedDataService.toggleSidenav(true);
  }

  closeSidenav() {
    this.sharedDataService.toggleSidenav(false);
  }

  menuenter() {
    this.isMatMenuOpen = true;
    if (this.isMatMenu2Open) {
      this.isMatMenu2Open = false;
    }
  }

  menuLeave(trigger, button) {
    setTimeout(() => {
      if (!this.isMatMenu2Open && !this.enteredButton) {
        this.isMatMenuOpen = false;
        trigger.closeMenu();
        this.ren.removeClass(button['_elementRef'].nativeElement, 'cdk-focused');
        this.ren.removeClass(button['_elementRef'].nativeElement, 'cdk-program-focused');
      } else {
        this.isMatMenuOpen = false;
      }
    }, 80)
  }

  menu2enter() {
    this.isMatMenu2Open = true;
  }

  menu2Leave(trigger1, trigger2, button) {
    setTimeout(() => {
      if (this.isMatMenu2Open) {
        trigger1.closeMenu();
        this.isMatMenuOpen = false;
        this.isMatMenu2Open = false;
        this.enteredButton = false;
        this.ren.removeClass(button['_elementRef'].nativeElement, 'cdk-focused');
        this.ren.removeClass(button['_elementRef'].nativeElement, 'cdk-program-focused');
      } else {
        this.isMatMenu2Open = false;
        trigger2.closeMenu();
      }
    }, 100)
  }

  buttonEnter(trigger) {
    setTimeout(() => {
      if (this.prevButtonTrigger && this.prevButtonTrigger !== trigger) {
        // Close the previous menu
        this.prevButtonTrigger.closeMenu();
        this.prevButtonTrigger = trigger;
        this.isMatMenuOpen = false;
        this.isMatMenu2Open = false;
  
        // Open the new menu and remove unwanted classes if items exist
        trigger.openMenu();
        if (trigger.menu?.items?.first) {
          this.ren.removeClass(
            trigger.menu.items.first['_elementRef']?.nativeElement,
            'cdk-focused'
          );
          this.ren.removeClass(
            trigger.menu.items.first['_elementRef']?.nativeElement,
            'cdk-program-focused'
          );
        }
      } else if (!this.isMatMenuOpen) {
        // Handle first-time menu open
        this.enteredButton = true;
        this.prevButtonTrigger = trigger;
  
        trigger.openMenu();
        if (trigger.menu?.items?.first) {
          this.ren.removeClass(
            trigger.menu.items.first['_elementRef']?.nativeElement,
            'cdk-focused'
          );
          this.ren.removeClass(
            trigger.menu.items.first['_elementRef']?.nativeElement,
            'cdk-program-focused'
          );
        }
      } else {
        // Handle case where menu is already open
        this.enteredButton = true;
        this.prevButtonTrigger = trigger;
      }
    });
  }
  

  buttonLeave(trigger, button) {
    setTimeout(() => {
      if (this.enteredButton && !this.isMatMenuOpen) {
        trigger.closeMenu();
        this.ren.removeClass(button['_elementRef'].nativeElement, 'cdk-focused');
        this.ren.removeClass(button['_elementRef'].nativeElement, 'cdk-program-focused');
      } if (!this.isMatMenuOpen) {
        trigger.closeMenu();
        this.ren.removeClass(button['_elementRef'].nativeElement, 'cdk-focused');
        this.ren.removeClass(button['_elementRef'].nativeElement, 'cdk-program-focused');
      } else {
        this.enteredButton = false;
      }
    }, 100)
  }

}
